export const generateWebhookSecret = () =>
  [...Array<undefined>(20)].map(() => Math.floor(Math.random() * 16).toString(16)).join("");
